function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("style", null, ".carbonMonoxide-icon{fill:url(#carbonMonoxide);}"), /*#__PURE__*/React.createElement("radialGradient", {
  id: "carbonMonoxide",
  x1: 35,
  y1: 8.1,
  x2: 35,
  y2: 62.1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FAB800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "70%",
  stopColor: "#038FC7"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "carbonMonoxide-icon",
  d: "m 38.963795,17.501905 c -5.05044,-1.4e-4 -9.99985,2.05258 -13.57032,5.62305 -3.57047,3.57047 -5.62319,8.51988 -5.62304,13.57031 -1.5e-4,5.05043 2.05257,9.99985 5.62304,13.57031 3.57047,3.57048 8.51989,5.62319 13.57032,5.62305 a 2.0002,2.0002 0 0 0 0.006,0 c 2.48744,-0.007 4.93319,-0.57972 7.23047,-1.52539 l 5.24219,6.03125 c -1.07641,2.12269 -1.73646,4.44832 -1.74219,6.83398 a 2.0002,2.0002 0 0 0 0,0.004 c -3.8e-4,4.02164 1.62755,7.94942 4.47071,10.79297 2.84313,2.84353 6.77108,4.47249 10.79297,4.47266 4.02173,3.8e-4 7.95094,-1.62672 10.79492,-4.4707 2.84398,-2.84399 4.47108,-6.77318 4.4707,-10.79493 -1.7e-4,-4.02188 -1.62913,-7.94983 -4.47266,-10.79296 -2.84355,-2.84316 -6.77134,-4.47109 -10.79296,-4.47071 a 2.0002,2.0002 0 0 0 -0.002,0 c -2.01673,0.002 -3.99168,0.48543 -5.84765,1.26172 l -4.64844,-5.34961 c 2.34218,-3.24696 3.68639,-7.17133 3.6914,-11.18359 a 2.0002,2.0002 0 0 0 0,-0.002 c 1.5e-4,-5.05043 -2.05258,-9.99985 -5.62304,-13.57031 -3.57047,-3.57047 -8.51989,-5.62319 -13.57031,-5.62305 z m 0,4 c 3.95162,-1.1e-4 7.94724,1.65623 10.74218,4.45117 2.79449,2.79449 4.45075,6.78925 4.45117,10.74024 -0.004,3.42796 -1.23439,6.88798 -3.39453,9.55078 a 2.0002,2.0002 0 0 0 -0.002,0.002 c -0.83287,1.02986 -0.80509,2.54387 0.0645,3.54297 l -0.002,0 5.82422,6.70117 c 0.8168,0.941 2.1927,1.21657 3.30859,0.66211 a 2.0002,2.0002 0 0 0 0.002,0 c 1.5452,-0.76969 3.28148,-1.18147 5.00586,-1.18359 2.92333,-2.8e-4 5.89721,1.23148 7.96484,3.29882 2.06765,2.06737 3.30065,5.04176 3.30078,7.96485 2.8e-4,2.92384 -1.23153,5.89951 -3.29883,7.96679 -2.06728,2.06729 -5.04295,3.29911 -7.96679,3.29883 -2.9231,-1.2e-4 -5.89748,-1.23313 -7.96485,-3.30078 -2.06644,-2.06673 -3.29803,-5.03882 -3.29883,-7.96094 l 0,-0.002 c 0,-6.3e-4 0,-0.001 0,-0.002 0.005,-1.97844 0.55244,-3.97549 1.55664,-5.68164 a 2.0002,2.0002 0 0 0 0.002,0 c 0.59677,-1.01516 0.47609,-2.31888 -0.29688,-3.20703 l -0.002,-0.002 -6.28516,-7.23047 c -0.8045,-0.92504 -2.15151,-1.20771 -3.25976,-0.68359 -2.00516,0.94882 -4.23342,1.45411 -6.45117,1.46094 -3.95163,1.1e-4 -7.94726,-1.65623 -10.74219,-4.45117 -2.79495,-2.79495 -4.45129,-6.79056 -4.45117,-10.74219 -1.2e-4,-3.95163 1.65622,-7.94724 4.45117,-10.74219 2.79493,-2.79494 6.79056,-4.45128 10.74219,-4.45117 z m 12.8457,38.02149 0.002,0 c -7.4e-4,10e-4 -10e-4,0.003 -0.002,0.004 7.1e-4,-10e-4 -7.2e-4,-0.003 0,-0.004 z"
});

function SvgCarbonMonoxide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    r: 0,
    cy: 56.791348,
    cx: 50.75671,
    style: {
      opacity: 1,
      fill: "#1A1A1A",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), _ref3));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonMonoxide);
export default __webpack_public_path__ + "static/media/carbonMonoxide.3c9b7489.svg";
export { ForwardRef as ReactComponent };